import {
  ClaimDocumentsAction,
  ClaimDocumentsActionTypes
} from './claim-documents.actions';
import { ClaimsFileType, Parameter } from '@ecosure-suite/shared/utils-helpers';
import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

export const CLAIMDOCUMENTS_FEATURE_KEY = 'clClaimDocuments';

/**
 * Interface for the 'ClaimDocuments' data used in
 *  - ClaimDocumentsState, and
 *  - claimDocumentsReducer
 *
 *  Note: replace if already defined in another module
 */
import { ClaimDocument } from './claim-documents.models';

export const claimDocumentEntityAdapter: EntityAdapter<
  ClaimDocument
> = createEntityAdapter<ClaimDocument>({
  selectId: (document: ClaimDocument) => document.id,
  sortComparer: false
});

export interface ClaimDocumentsState extends EntityState<ClaimDocument> {
  selectedId?: number; // which ClaimDocuments record has been selected
  loaded: boolean; // has the ClaimDocuments list been loaded
  loading: boolean;
  error?: any; // last none error (if any)
}

export interface ClaimDocumentsPartialState {
  readonly [CLAIMDOCUMENTS_FEATURE_KEY]: ClaimDocumentsState;
}

export const initialState: ClaimDocumentsState = claimDocumentEntityAdapter.getInitialState(
  {
    loaded: false,
    loading: false
  }
);

export function claimDocumentsReducer(
  state: ClaimDocumentsState = initialState,
  action: ClaimDocumentsAction
): ClaimDocumentsState {
  switch (action.type) {
    case ClaimDocumentsActionTypes.LOAD_CLAIM_OWNER_DOCUMENTS:
    case ClaimDocumentsActionTypes.SAVE_CLAIM_DOCUMENT_INFORMATION:
    case ClaimDocumentsActionTypes.UPDATE_CLAIM_DOCUMENT_INFORMATION:
      return {
        ...state,
        loaded: false,
        loading: true,
        error: undefined
      };

    case ClaimDocumentsActionTypes.SAVE_UPLOAD_SUCCESS:
      return {
        ...claimDocumentEntityAdapter.upsertOne(action.payload, state),
        loaded: true,
        loading: false
      };

    case ClaimDocumentsActionTypes.UPDATE_UPLOAD_SUCCESS:
      return {
        ...claimDocumentEntityAdapter.updateOne(
          { id: action.payload.id, changes: action.payload },
          state
        ),
        loaded: true,
        loading: false
      };

    case ClaimDocumentsActionTypes.LOAD_CLAIM_OWNER_DOCUMENTS_SUCCESS:
      return {
        ...claimDocumentEntityAdapter.addMany(action.payload, state),
        loaded: true,
        loading: false
      };

    case ClaimDocumentsActionTypes.SAVE_UPLOAD_FAIL:
    case ClaimDocumentsActionTypes.UPDATE_UPLOAD_FAIL:
      return {
        ...state,
        loaded: false,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}
